module.exports = __webpack_public_path__ + "img/feature_buy_ko.aa9f0900.png";